<div class="tw-flex tw-flex-col tw-gap-4 tw-w-full">
  <!--  filter-->
  <div class="tw-flex tw-flex-col tw-gap-5">
    <app-dropdown-multiselect
      [title]="'Countries'"
      [options]="countries"
      [selectedOptions]="selectedCountries"
      (selectionChange)="onCountrySelect($event)"
      [testId]="'country-dropdown'"
    ></app-dropdown-multiselect>

    <app-dropdown-multiselect
      [title]="'Institutions'"
      [options]="institutions"
      [selectedOptions]="selectedInstitutions"
      [disabledOptions]="disabledInstitutions"
      (selectionChange)="onInstitutionSelect($event)"
      [testId]="'institutions-dropdown'"
    ></app-dropdown-multiselect>

    <app-dropdown-multiselect
      [title]="'Accounts'"
      [options]="accounts"
      [selectedOptions]="selectedAccounts"
      [disabledOptions]="disabledAccounts"
      (selectionChange)="onAccountSelect($event)"
      [testId]="'accounts-dropdown'"
    ></app-dropdown-multiselect>

    @if (viewsService.currentView() === View.PAST) {
      <app-dropdown-multiselect
        [title]="'Categories'"
        [options]="categories"
        [selectedOptions]="selectedCategories"
        [disabledOptions]="disabledCategories"
        (selectionChange)="onCategorySelect($event)"
        [testId]="'categories-dropdown'"
      ></app-dropdown-multiselect>
    }
  </div>

  <!--  Group by-->
  <!--@Sinan TODO this block is commented out to be enabled later on. No need to delete it -->
  <!--  <div class="tw-flex tw-flex-col tw-gap-2 tw-w-full">
    <span class="tw-font-medium tw-text-sm tw-text-dt-text-secondary">GROUP BY</span>
    <app-dropdown-multiselect
      [title]="'Group By'"
      [options]="groupByOptions"
      [selectedOptions]="selectedGroupByOptions"
      (selectionChange)="onGroupBySelectionChange($event)"
    ></app-dropdown-multiselect>
  </div>-->
  <!--  Group by-->

  @if (!inDialogFooter) {
    <ng-container *ngTemplateOutlet="footer"></ng-container>
  }
</div>

<!-- Rendered in the dialog-wrapper's footer slot when opened in one (see the component). -->
<ng-template #footer>
  <div class="tw-flex tw-flex-col tw-py-5">
    <div class="tw-flex tw-w-full tw-gap-2 sm:tw-flex-col">
      <app-gloss-button
        class="tw-flex-1 sm:tw-w-full"
        [options]="cancelButtonOptions"
      ></app-gloss-button>
      <app-gloss-button
        class="tw-flex-1 sm:tw-w-full"
        [options]="confirmButtonOptions"
      ></app-gloss-button>
    </div>
    <div class="tw-hidden sm:tw-flex tw-justify-center tw-pt-3">
      <span class="tw-h-1 tw-w-24 tw-rounded-full tw-bg-dt-border-secondary"></span>
    </div>
  </div>
</ng-template>
